import { authenticateAgnosticUser } from 'auth/use-cases/authenticateAgnosticUser'

import { type AttachmentRequestBody } from '../infra/AttachmentRepository'
import { createAttachmentRepository } from '../infra/createAttachmentRepository'
import { type HttpClientConfig } from '../infra/http/HttpClient'
import { openFile } from '../utils/browser'

export async function downloadAttachment(
  body: AttachmentRequestBody & { rateUuid: string },
  config?: Partial<HttpClientConfig>
) {
  await authenticateAgnosticUser({ entityIdentifier: body.rateUuid })

  const repository = createAttachmentRepository()

  const attachmentURL = await repository.getAttachmentURL(body, config)

  openFile(attachmentURL)

  return attachmentURL
}
